import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSettingShowSideBarV2UI } from "@faire/retailer-visitor-shared/settings/useSettingShowSideBarV2UI";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
export var SettingsSectionHeader = function(param) {
    var title = param.title, description = param.description;
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    var showV2UI = useSettingShowSideBarV2UI();
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                size: isTabletAndBelow && showV2UI ? 16 : 20
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "subheadingSansMedium",
                    desktopAndAbove: "sectionHeaderSansMedium"
                },
                children: title
            }),
            description ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: 8
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: description
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Spacer, {
                size: 20
            })
        ]
    });
};
